/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'notification';
const componentName = 'cloud-status';
const prefix = `${moduleName}.${componentName}`;

export const detailsLabel = `${prefix}.detailsLabel`;

export const ENGLISH = {
    [detailsLabel]: 'Details',
};
